export const mfeEndpointNames = {
  PAYMENT_PAGE: '@blaze/mfe-payment-page',
  TAXES_PAGE: '@blaze/mfe-taxes-page',
  SYSTEM_ACTIVITY_LOG_PAGE: '@blaze/mfe-audit-log',
  COMPLIANCE_PAGE: '@blaze/mfe-compliance-page',
  FEES_PAGE: '@blaze/mfe-fees-page',
  LOYALTY_PAGE: '@blaze/mfe-loyalty-page',
}

const importMfe = (endPointName) => {
  const overrideEndPointName = localStorage.getItem(endPointName)

  return window.System.import(overrideEndPointName || endPointName)
}

/**
 * In this codebase, `System` is inaccessible in React components so it is attached to `window` in `public/index.html`.
 */
export const mfeConfigs = {
  LOAD_PAYMENT_PAGE: () => importMfe(mfeEndpointNames.PAYMENT_PAGE),
  LOAD_TAXES_PAGE: () => importMfe(mfeEndpointNames.TAXES_PAGE),
  LOAD_SYSTEM_ACTIVITY_LOG_PAGE: () => importMfe(mfeEndpointNames.SYSTEM_ACTIVITY_LOG_PAGE),
  LOAD_COMPLIANCE_PAGE: () => importMfe(mfeEndpointNames.COMPLIANCE_PAGE),
  LOAD_FEES_PAGE: () => importMfe(mfeEndpointNames.FEES_PAGE),
  LOAD_LOYALTY_PAGE: () => importMfe(mfeEndpointNames.LOYALTY_PAGE),
}



// WEBPACK FOOTER //
// ./src/utils/mfe.js